import "./IconHamburger.scss";
import { ReactComponent as HamburgerIcon } from "./svg/icon_hamburger.svg";

export const IconHamburger = () => {
  return (
    <span className="IconHamburger">
      <HamburgerIcon />
    </span>
  );
};
